@if (hasLocationOrStation()) {
  <div class="location-station-card">
    @if (!hideLabel) {
      <div class="location-station-header">
        <div class="location-station-label">LOCATION / STATION:</div>
        @if (isEditable) {
          <mat-icon
            [matMenuTriggerFor]="locationStationCardMenu"
            class="location-station-menu-icon"
            (click)="$event.stopPropagation()"
            >more_horiz
          </mat-icon>
          <mat-menu #locationStationCardMenu="matMenu">
            <button (click)="deleteLocation($event)" mat-menu-item>
              <mat-icon svgIcon="trash" />
              Clear
            </button>
          </mat-menu>
        }
      </div>
    }

    <div class="location-station-box" (click)="openCard($event)">
      @if (stationRangeMapData?.geometry) {
        <div class="station-range-map-section cursor-pointer">
          <!-- Spec addendum §11: a linked record's capture takes the map's slot; the FROM / TO labels stay over it. -->
          @if (hasCapture) {
            <app-design-capture-preview [link]="mapFeatureLink" height="80px" [viewOnClick]="true" />
          } @else {
            <app-survey-data-map
              [geometry]="stationRangeMapData.geometry"
              (mapClicked)="openCard($event)"
            />
          }
          @if (stationRangeMapData.fromLabel) {
            <div class="station-map-label station-map-label-from">
              {{ stationRangeMapData.fromLabel }}
            </div>
          }
          @if (stationRangeMapData.toLabel) {
            <div class="station-map-label station-map-label-to">
              {{ stationRangeMapData.toLabel }}
            </div>
          }
        </div>
      } @else if (hasCapture) {
        <!-- Spec addendum §11: the marked-up capture in place of the minimap, same size. Its click opens the full
             picture (Sri 2026-09-28); the rest of the box and the card's "Edit location" open the picker. -->
        <app-design-capture-preview class="location-tile" [link]="mapFeatureLink" height="80px" [viewOnClick]="true" />
      } @else if (hasGpsLocation()) {
        <app-location-picker
          class="location-tile"
          [isDialog]="false"
          [latitude]="latitude"
          [longitude]="longitude"
          height="80px"
          [readOnly]="true"
        />
      }

      @if (normalizedStationRange) {
        @if (normalizedStationRange.alignment) {
          <div class="station-detail-block">
            <div class="station-range-sub-section-label">Alignment</div>
            <div class="station-detail-value">{{ normalizedStationRange.alignment }}</div>
          </div>
        }
        @if (normalizedStationRange.from?.station || normalizedStationRange.from?.offsetType || normalizedStationRange.from?.offsetDistance) {
          <div class="station-detail-block">
            <div class="station-range-sub-section-label">From</div>
            <div class="station-detail-value">
              {{ normalizedStationRange.from?.station }}
              @if (normalizedStationRange.from?.offsetType) {
                <span>, {{ normalizedStationRange.from?.offsetType }}</span>
              }
              @if (normalizedStationRange.from?.offsetDistance) {
                <span>, {{ normalizedStationRange.from?.offsetDistance }}</span>
              }
            </div>
          </div>
        }
        @if (normalizedStationRange.to?.station || normalizedStationRange.to?.offsetType || normalizedStationRange.to?.offsetDistance) {
          <div class="station-detail-block">
            <div class="station-range-sub-section-label">To</div>
            <div class="station-detail-value">
              {{ normalizedStationRange.to?.station }}
              @if (normalizedStationRange.to?.offsetType) {
                <span>, {{ normalizedStationRange.to?.offsetType }}</span>
              }
              @if (normalizedStationRange.to?.offsetDistance) {
                <span>, {{ normalizedStationRange.to?.offsetDistance }}</span>
              }
            </div>
          </div>
        }
      }

      @if (locationText) {
        <div class="station-detail-block">
          <div class="station-range-sub-section-label">Location</div>
          <div class="station-detail-value">{{ locationText }}</div>
        </div>
      }

      @if (mapFeatureLink) {
        <div class="station-detail-block" data-testid="location-card-design-context" role="group" aria-label="Design context" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <app-design-context
            [link]="mapFeatureLink"
            [collapseWhenCaptured]="true"
            [editable]="isEditable"
            [projectId]="projectId"
            [markupKind]="markupKind"
            (remove)="removeDesignContext()"
            (editLocation)="openCard()"
            (linkChange)="onDesignContextLinkChange($event)"
          />
        </div>
      }
    </div>
  </div>
}
